<app-install-pwa-prompt *ngIf="pwaInstallService.bannerVisible$ | async" />
<button
  type="button"
  class="freshchat-launcher btn btn-primary rounded-circle border-0 shadow d-flex align-items-center justify-content-center p-0 text-white position-fixed"
  *ngIf="
    freshChatService.shouldShowLauncher && !(freshChatService.open$ | async)
  "
  (click)="openFreshChatLauncher($event)"
  aria-label="Open live chat"
>
  <i class="bi bi-chat-dots-fill fs-4" aria-hidden="true"></i>
</button>
<app-chat-client-panel *ngIf="chatClientService.isEnabled" />
<router-outlet *ngIf="!isSiteUnderMaintenance"></router-outlet>
<div *ngIf="isSiteUnderMaintenance">
  <temporarily-unavailable></temporarily-unavailable>
</div>
